import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Paper, Box, Typography, makeStyles, Grid } from '@material-ui/core';
import KenInput from '../../components/KenInputField';
import { withRouter } from 'react-router-dom';
import KenButton from '../../components/KenButton/index';
import { otpGenerator } from '../../utils/Otp';
import clsx from 'clsx';
import { withFormik } from 'formik';
import { createContact, getContactByPhone } from '../../utils/ApiService';
import * as Yup from 'yup';
import configContext from '../../utils/config';
import KenSnackBar from '../../components/KenSnackbar';
import KenLoader from '../../components/KenLoader/KenLoader';
import KenSelect from '../../components/KenSelect';
import countryCodes from '../../json/countryISDCode.json';
import { sendOtpTo, isOtpValid, isUserAlreadyRegistered } from './helper';
import KenInputMobile from '../../components/KenInputMobile';
import { GLOBAL } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import { routes } from '../../utils/urls';

const useStyles = makeStyles((theme) => ({
  paper: {},
  hide: {
    display: 'none',
  },
  reSend: {
    cursor: 'pointer',
    float: 'right',
  },
  Heading: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.KenColors.neutral100,
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: 24,
  },
  change: {
    cursor: 'pointer',
  },
  registerLabel: {
    paddingBottom: 10,
    fontWeight: 'bold',
  },
}));

export default withRouter(function SignUpInfo(props) {
  return (
    <div>
      <FormikHoc {...props} />
    </div>
  );
});

const SignUpForm = (props) => {
  const { t } = useTranslation();
  let history = useHistory();
  const options = countryCodes.codes;
  const { config } = React.useContext(configContext);
  const {
    values,
    toggle,
    setFieldTouched,
    touched,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = props;

  const classes = useStyles();

  //Declare all states on top
  const [otp, setOtp] = React.useState();
  const [showOtpEnter, setShowOtpEnter] = React.useState(false);
  //snackBar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const [currentRow] = useState({});
  const [loader, setLoader] = React.useState(false);

  const [prog, setProg] = useState([
    {
      label: 'Training Partner',
      value: 'Training Partner',
    },
    {
      label: 'Assesment Partner',
      value: 'Assesment Partner',
    },
    {
      label: 'Corporate Partner',
      value: 'Corporate Partner',
    },
  ]);

  let phone = '';
  phone = values.countryCode + '' + values.phone;
  if (phone) {
    phone = phone.substring(1);
  }

  const signUpPayload = {
    // Email: values.email,
    // Phone: phone,
    // InstituteId: currentRow.instituteId,
    // First_Name: values.firstName,
    // Last_Name: values.lastName,
    // Gender: values.gender,
    // AcademicYear: GLOBAL.ACADEMIC_YEAR,
    // Self: GLOBAL.SELF.YES,
    records: {
      attributes: { type: 'Contact', referenceId: "ref'0" },
      Id: null,
      LastName: values.lastName,
      FirstName: values.firstName,
      hed__AlternateEmail__c: values.email,
      OtherPhone: phone,
    },
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === GLOBAL.REASONS.CLICKAWAY) return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const change = (name, e, index) => {
    setLoader(true);
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
    setLoader(false);
  };

  React.useEffect(() => {
    if (otp) {
      alert(`${t('snackbarMessages:noteOtp')} ${otp}`);
    }
  }, [otp]);

  const handleOtp = async () => {
    const otpto = config?.otpTo.toLocaleLowerCase();
    if (values.phone.length === 10) {
      const registeredUser = await isUserAlreadyRegistered(`${values.countryCode?.substring(1)}${values.phone}`);
      if (!registeredUser) {
        console.log('registeredUser', registeredUser);
        if (otpto === GLOBAL.OTP.ON_SCREEN) {
          setShowOtpEnter(true);
          setOtp(otpGenerator());
        } else {
          sendOtpTo(values.email, values.phone, otpto)
            .then((res) => {
              if (res.status === GLOBAL.RESPONSE_STATUS.SUCESS) {
                //In response we get "sucess", ignore spelling
                handleSnackbarOpen('success', t('validations:success_otp'));
                setShowOtpEnter(true);
              } else {
                handleSnackbarOpen('error', t('validations:fail_otp'));
              }
            })
            .catch((err) => {
              handleSnackbarOpen('error', t('validations:otp'));
            });
        }
      } else {
        handleSnackbarOpen('error', t('snackbarMessages:alreadyRegistered'));
      }
    } else {
      handleSnackbarOpen('error', t('validations:invalidMobile'));
    }
  };

  const createContactInfo = (payload) => {
    createContact(payload).then((resp) => {
      if (
        resp.type !== GLOBAL.CONTACT_TYPE.EXISTING &&
        resp.Id !== GLOBAL.STRING_FLAG.NULL
      ) {
        localStorage.setItem('contactID', resp.Id);
        localStorage.setItem('StudentID', resp.Id);
        localStorage.setItem('userPhone', phone);
        getContactByPhone(phone).then((user) => {
          history.push({
            pathname: `${routes.instructions}${values.academicProgram}`,
            search: `?name=${values.academicProgram}&instId=${values.instituteId}&year=${values.academicyears}`,
            state: {
              academicProgramDetails: '',
              userDetails: {
                ...user.data[0],
                applyingForSelf: true,
                relationWithApplicant: '',
              },
              applicantDetails: true ? user.data[0] : {},
              applicationDetails: {
                draft: false,
              },
              //ParentId: user.ParentId,
              Email: user.data[0].hed__AlternateEmail__c,
            },
          });
        });
      } else {
        handleSnackbarOpen('error', t('snackbarMessages:invalidEmailPhone'));
      }
    });
  };

  values.handleSubmitotp = () => {
    localStorage.setItem('contactID', "003N000001tKwFCIA0");
    localStorage.setItem('StudentID', "003N000001tKwFCIA0");
    localStorage.setItem('userPhone', "9999999999");
    // history.push("/instructions");
    history.push({
      pathname: `${routes.instructions}${values.academicProgram}`,
      search: `?name=${values.academicProgram}&instId=${values.instituteId}&year=${values.academicyears}`,
      state: {
        academicProgramDetails: '',
        userDetails: {
          // ...user.data[0],
          applyingForSelf: true,
          relationWithApplicant: '',
        },
        applicantDetails: true ? {} : {},
        applicationDetails: {
          draft: false,
        },
        //ParentId: user.ParentId,
        Email: "test@ken42.com",
      },
    });
    // if (config?.otpTo.toLocaleLowerCase() === GLOBAL.OTP.ON_SCREEN) {
    //   if (otp === values.userOTP) {
    //     createContactInfo(signUpPayload);
    //   } else {
    //     handleSnackbarOpen('error', t('validations:otp'));
    //     setShowOtpEnter(true);
    //   }
    // } else {
    //   isOtpValid(values.email, phone, config?.otpTo, values.userOTP).then(
    //     (res) => {
    //       if (res.status) {
    //         createContactInfo(signUpPayload);
    //       } else {
    //         handleSnackbarOpen('error', t('validations:otp'));
    //         setShowOtpEnter(true);
    //       }
    //     }
    //   );
    // }
  };

  return (
    <div>
      <form>
        <Paper className={classes.paper} elevation={0}>
          <Box textAlign="center">
            <Box pt={1}>
              <Typography variant="body2" className={classes.registerLabel}>
                {t('titles:signUp_heading')}
              </Typography>
            </Box>

            <Box pt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={6}>
                  <KenInput
                    required
                    label={t('labels:firstName')}
                    name="firstName"
                    value={values.firstName}
                    onChange={change.bind(null, 'firstName')}
                    errors={errors.firstName}
                    touched={touched.firstName}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <KenInput
                    required
                    label={t('labels:lastName')}
                    name="lastName"
                    value={values.lastName}
                    onChange={change.bind(null, 'lastName')}
                    errors={errors.lastName}
                    touched={touched.lastName}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box pt={1}>
              <KenInput
                required
                label={t('labels:email')}
                name="email"
                value={values.email}
                onChange={change.bind(null, 'email')}
                errors={errors.email}
                touched={touched.email}
              />
            </Box>
            <Box pt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <KenInputMobile
                    required
                    label={t('labels:mobile')}
                    inputName="phone"
                    startAdornment
                    onchangeInput={change.bind(null, 'phone')}
                    inputvalue={values.phone}
                    errors={errors.phone}
                    touched={touched.phone}
                    optionalLabel={false}
                    options={options}
                    selectName="countryCode"
                    countrycodeValue={values.countryCode}
                    setFieldValue={setFieldValue}
                    onChangeSelect={change.bind(null, 'countryCode')}
                    defaultCountryCode={GLOBAL.COUNTRY_CODES.DEFAULT}
                  />
                </Grid>
              </Grid>
            </Box>
            {loader && <KenLoader />}
            <Box pt={1}>
              <KenSelect
                optionalLabel={false}
                options={prog}
                value={values.prog}
                name="academicProgram"
                label={t('labels:Applying For')}
                onChange={change.bind(null, 'academicProgram')}
              />
            </Box>
            <Box pt={1}>
              <KenSelect
                optionalLabel={false}
                options={['2021', '2022']}
                value={values.academicyears}
                name="academicyears"
                label={t('labels:Year')}
                onChange={change.bind(null, 'academicyears')}
              />
            </Box>
            <div>
              {/* <Box
                className={clsx({ [classes.hide]: showOtpEnter })}
                pt={1}
                display="flex"
                justifyContent="flex-end"
              >
                <KenButton
                  variant="secondary"
                  onClick={() => {
                    handleOtp();
                  }}
                >
                  {t('buttons:getOtp')}
                </KenButton>
              </Box> */}
                <Box pt={1} display="flex" justifyContent="flex-end">
                  <KenButton variant="primary" onClick={handleSubmit}>
                    {t('buttons:go')}
                  </KenButton>
                </Box>

              <div className={clsx({ [classes.hide]: !showOtpEnter })}>
                <Box pt={1}>
                  <Typography
                    color="primary"
                    className={classes.reSend}
                    onClick={() => {
                      handleOtp();
                    }}
                  >
                    {t('buttons:resendOtp')}
                  </Typography>
                  <KenInput
                    required
                    label={t('labels:enterOtp')}
                    name="userOTP"
                    errors={errors.userOTP}
                    touched={touched.userOTP}
                    onChange={change.bind(null, 'userOTP')}
                    value={values.userOTP}
                  />
                </Box>

                <Box pt={1} display="flex" justifyContent="flex-end">
                  <KenButton variant="primary" onClick={handleSubmit}>
                    {t('buttons:go')}
                  </KenButton>
                </Box>
                <div></div>
              </div>
            </div>
          </Box>
          {/* <Box pt={1} display="flex" justifyContent="center">
            <Typography
              className={classes.change}
              onClick={toggle}
              variant="body2"
            >
              {t('titles:register_footer')}
            </Typography>
          </Box> */}
        </Paper>
      </form>
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={2000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </div>
  );
};

const FormikHoc = (props) => {
  const { t } = useTranslation();
  const SignUpFormik = withFormik({
    mapPropsToValues: () => ({
      email: '',
      phone: '',
      countryCode: '',
      firstName: '',
      lastName: '',
      userOTP: '',
    }),

    validationSchema: Yup.object({
      firstName: Yup.string()
        .matches(GLOBAL.REGEX.NAME, t('validations:firstName_match'))
        .max(15, t('validations:firstName_max'))
        .required(t('validations:required')),
      lastName: Yup.string()
        .matches(GLOBAL.REGEX.NAME, t('validations:lastName_match'))
        .max(20, t('validations:lastName_max'))
        .required(t('validations:required')),
      phone: Yup.string()
        .required()
        .matches(GLOBAL.REGEX.PHONE_NUMBER, t('validations:phone_invalid'))
        .test('len', t('validations:phone_digits'), (val) => {
          if (val) {
            return val.toString().length === 10;
          }
        }),
      email: Yup.string().email(t('validations:email')),
      // userOTP: Yup.string().required(t('validations:required')),
    }),

    handleSubmit: (values) => {
      values.handleSubmitotp();
    },

    displayName: 'SignUpInformation',
  })(SignUpForm);

  return <SignUpFormik {...props} />;
};
